import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const deleteEntry: YJSChangeHandler<DatabaseChangeType.DELETE_ENTRY> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    db.deleteEntries(change.entryIds);

    change.entryIds.forEach((entryId) => {
      // Remove all comments on the entry
      db.fields.forEach((fieldId: string) => {
        const valueId = getValueId(entryId, fieldId);
        if (valueId in db.commentThreads) {
          db.removeCommentsOnValue(valueId);
        }
      });
    });
  });
};
